import { useCallback } from 'react';
import { defineMessages, useIntl } from 'react-intl';

const messages = defineMessages({
  defaultWorkspaceName: {
    defaultMessage: "{firstName}'s workspace",
    id: 'eYA2j7Kfu4',
    description:
      'Pre-filled default workspace name during onboarding/setup, e.g. "Jane\'s workspace". The English possessive does not translate directly — translators should reorder for their language (e.g. "Espacio de {firstName}").',
  },
});

/**
 * Returns a builder for the pre-filled workspace-name default, routed through
 * react-intl so the `'s` possessive can be localised per language rather than
 * hardcoded in English. Shared by the onboarding-v2 and legacy-survey flows.
 */
export function useWorkspaceNameDefault() {
  const intl = useIntl();
  return useCallback(
    (firstName: string) =>
      intl.formatMessage(messages.defaultWorkspaceName, { firstName }),
    [intl]
  );
}
